import { getGridLocalization } from "../utils/getGridLocalization.mjs";
import { GRID_DEFAULT_LOCALE_TEXT } from "../constants/localeTextConstants.mjs";
export const enUS = getGridLocalization(GRID_DEFAULT_LOCALE_TEXT);